/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authManageLabelerService'

type $nsid = typeof $nsid

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('repo', {
      action: ['create', 'update', 'delete'],
      collection: ['app.bsky.labeler.service'],
    }),
  ],
  {
    title: 'Manage Hosted Labeling Service',
    'title:lang': {},
    detail: 'Configure labeler declaration records.',
    'detail:lang': {},
  },
)

export { main }
